import {IconicHelpers} from './helpers.js';
import hoverintent from 'hoverintent';

/**
 * Panels.
 *
 * Mainly used on the homepage. Acts like an accordion.
 */
class IconicPanels {
	/**
	 * Class names.
	 *
	 * @type {{}}
	 */
	classes = {
		'panels': '.iconic-panels',
		'panelLinks': '.iconic-panels__link',
		'panelLinksMore': '.iconic-panels__link-more',
		'panelContent': '.iconic-panels__panel',
	};

	/**
	 * Run panels.
	 */
	constructor() {
		this.watch();
	};

	/**
	 * Watch for events.
	 */
	watch = () => {
		document.querySelectorAll( this.classes.panelLinks ).forEach( ( panelLink ) => {
			[ 'click', 'touchstart' ].forEach( ( e ) => {
				panelLink.addEventListener( e, () => {
					this.togglePanel( panelLink );
				} );
			} );
		} );
	};

	/**
	 * Toggle panel.
	 *
	 * @param panelLink
	 */
	togglePanel = ( panelLink ) => {
		let openClass = IconicHelpers.getUsableClassName( this.classes.panelLinks, '--open' ),
			activeClass = IconicHelpers.getUsableClassName( this.classes.panelContent, '--active' ),
			panelParent = panelLink.closest( this.classes.panels ),
			panelLinks = panelParent.querySelectorAll( this.classes.panelLinks ),
			panelContents = panelParent.querySelectorAll( this.classes.panelContent ),
			linkIndex = [ ...panelLinks ].indexOf( panelLink );

		// Remove active states.
		panelContents.forEach( node => {
			node.classList.remove( activeClass );
		} );

		// Remove active states.
		panelLinks.forEach( node => {
			node.classList.remove( openClass );
		} );

		panelParent.scrollIntoView( {
			behavior: 'smooth',
			block: 'center'
		} );

		// Add active states.
		panelLink.classList.add( openClass );
		[ ...panelContents ][ linkIndex ].classList.add( activeClass );
	};
}

export {IconicPanels};